import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { useNavigate } from 'react-router-dom';
import { Colors, MediaBreakPointUp, Sizes } from '@lean-body/components/styles';
import { ZIndex } from '../../constants';
import { routes } from '@lean-body/src/route';
import { InputSearch } from '@lean-body/components/molecules';
import { ArrowDirection, ArrowIcon } from '../../atoms/icons/arrow_icon';
import { ClockIcon, searchDurationClockMinutes } from '../../atoms/icons/clock_icon';
import { RadioWavesIcon } from '../../atoms/icons/radio_waves_icon';
import { circleLabel } from './circle_label';
import { SearchLandingCircles } from './search_landing_circles';
import { SearchLandingHistories } from './search_landing_histories';
import { SearchLandingInstructors } from './search_landing_instructors';
import { SearchLandingMetrics } from './search_landing_metrics';
export const SearchLanding = ({ config, keyword, searchHistories, styles: contentStyles, partTags, trainers, durations, difficulties, onChangeKeyword, onSubmitKeyword, onClearHistories, onBack, }) => {
    const navigate = useNavigate();
    const goResult = (search) => {
        navigate({ pathname: routes.SEARCH_RESULT.compile(), search });
    };
    const onSubmit = (e) => {
        e.preventDefault();
        if (!keyword || keyword.length < 2)
            return;
        onSubmitKeyword(keyword);
    };
    const genreItems = contentStyles.map((style) => ({
        id: style.id,
        name: circleLabel(style.name),
        imageUrl: style.thumbnailURL(config),
    }));
    const partItems = partTags.map((tag) => ({
        id: tag.id,
        name: tag.name,
        imageUrl: tag.thumbnailURL(config),
    }));
    const durationItems = durations.map(({ name, value }, index) => ({
        key: String(value),
        label: name,
        icon: (React.createElement(ClockIcon, { color: Colors.PrimaryDark, minute: searchDurationClockMinutes[index], classObject: styles.metricIcon })),
    }));
    const difficultyItems = difficulties.map((difficulty) => ({
        key: String(difficulty.id),
        label: difficulty.name,
        icon: (React.createElement(RadioWavesIcon, { difficultyDegree: difficulty.degree, fillColor: Colors.PrimaryDark, emptyColor: Colors.BlueLighterB, classObject: styles.metricIcon })),
    }));
    const instructorItems = trainers.map((trainer) => ({
        id: trainer.id,
        name: trainer.name,
        imageUrl: trainer.thumbnailURL,
    }));
    const openGenre = (id) => {
        goResult(`style_id=${id}`);
    };
    const openPart = (id) => {
        const tag = partTags.find((item) => item.id === id);
        if (!tag)
            return;
        goResult(`q=${encodeURIComponent(tag.name)}&tag_id=${tag.id}`);
    };
    const openDuration = (key) => {
        goResult(`duration_id=${key}`);
    };
    const openDifficulty = (key) => {
        goResult(`difficulty_id=${key}`);
    };
    const openInstructor = (id) => {
        const trainer = trainers.find((item) => item.id === id);
        if (!trainer)
            return;
        goResult(`q=${encodeURIComponent(trainer.name)}&trainer_id=${trainer.id}`);
    };
    return (React.createElement("div", { className: css(styles.page) },
        React.createElement("div", { className: css(styles.stickySearch) },
            React.createElement("div", { className: css(styles.searchRow) },
                React.createElement("div", { className: css(styles.back), onClick: onBack, "aria-label": "\u623B\u308B" },
                    React.createElement(ArrowIcon, { direction: ArrowDirection.left, color: Colors.Black })),
                React.createElement(InputSearch, { className: css(styles.searchInput), keywordValue: keyword || '', onChangeKeyword: onChangeKeyword, submitDisabled: !keyword || keyword.length < 2, onSubmit: onSubmit, placeholder: "\u30EC\u30C3\u30B9\u30F3\u3092\u691C\u7D22\u3059\u308B", autoFocus: true }))),
        React.createElement("div", { className: css(styles.body) },
            searchHistories.length > 0 && (React.createElement(SearchLandingHistories, { histories: searchHistories, onClickHistory: onSubmitKeyword, onClearHistories: onClearHistories })),
            React.createElement(SearchLandingCircles, { title: "\uD83E\uDDE9 \u30B8\u30E3\u30F3\u30EB", items: genreItems, onClick: openGenre }),
            React.createElement(SearchLandingMetrics, { title: "\u23F3 \u30EC\u30C3\u30B9\u30F3\u6642\u9593", columns: 4, items: durationItems, onClick: openDuration }),
            React.createElement(SearchLandingMetrics, { title: "\uD83D\uDD25 \u96E3\u6613\u5EA6", columns: 3, items: difficultyItems, onClick: openDifficulty }),
            React.createElement(SearchLandingCircles, { title: "\uD83E\uDDB5 \u6C17\u306B\u306A\u308B\u90E8\u4F4D", items: partItems, onClick: openPart }),
            React.createElement(SearchLandingInstructors, { items: instructorItems, onClick: openInstructor }))));
};
const styles = StyleSheet.create({
    page: {
        width: '100%',
        maxWidth: 1024,
        margin: '0 auto',
    },
    stickySearch: {
        position: 'sticky',
        top: Sizes.MobileHeaderHeight,
        zIndex: ZIndex.Header,
        backgroundColor: Colors.White,
        padding: '16px 16px 12px',
        [MediaBreakPointUp.MD]: {
            top: 0,
            padding: '38px 24px 12px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '38px 32px 12px',
        },
    },
    body: {
        marginTop: -24,
        padding: '0 16px 16px',
        [MediaBreakPointUp.MD]: {
            padding: '0 24px 48px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '0 32px 48px',
        },
    },
    searchRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
    },
    back: {
        display: 'flex',
        cursor: 'pointer',
    },
    searchInput: {
        flex: 1,
        minWidth: 0,
    },
    metricIcon: {
        width: 24,
        height: 24,
    },
});
